import { ref } from "vue";
import { fogoSession } from "@/composables/useFogoSession";
import { Network } from "@fogo/sessions-sdk";

const EXPLORER_BASE = "https://fogoscan.com"

const NETWORK_CLUSTER_MAP: Record<Network, string> = {
    [Network.Testnet]: "testnet",
    [Network.Mainnet]: "",
}

function getExplorerUrl(sig: string): string {
    const cluster = NETWORK_CLUSTER_MAP[fogoSession.options.network]
    const suffix = cluster ? `?cluster=${cluster}` : ""
    return `${EXPLORER_BASE}/tx/${sig}${suffix}`
}

const EXPLORER_ICON = `<i class="toast-explorer-link"></i>`

export function useToast() {
    const toast = ref()
    function init(toastInstance: any) {
        toast.value = toastInstance
    }

    function truncateMsg(msg: any, maxLen = 120): string {
        const str = typeof msg === 'string' ? msg : String(msg ?? '')
        return str.length > maxLen ? str.slice(0, maxLen) + '…' : str
    }

    function error(msg: any, title = "", sig?: string) {
        if (msg === null || msg === undefined) return
        if (!toast.value) { console.error('[toast not ready]', msg); return }
        const display = truncateMsg(msg)
        if (!sig) return toast.value.e(display, title)
        toast.value.e({
            msg: display,
            onClicked: () => window.open(getExplorerUrl(sig), '_blank'),
            timeout: 5000,
        }, `${title}${EXPLORER_ICON}`)
    }

    function success(msg: any, title = "") {
        if (!toast.value) { console.warn('[toast not ready]', msg); return }
        toast.value.s(truncateMsg(msg), title)
    }

    /**
     * Show info toast notification
     * @note Added for future use, not currently called
     */
    function info(msg: any, title = "") {
        if (!toast.value) { console.warn('[toast not ready]', msg); return }
        toast.value.i(truncateMsg(msg), title)
    }

    return {
        init,
        error,
        success,
        info,
    }
}

export const toast = useToast()